// project imports
import services from 'utils/mockAdapter';

// types
import { UserProfile } from 'types/user-profile';

// user profile list
const users: UserProfile[] = [
    {
        // id: '#1Profile_Elmore',
        // avatar: 'friend-1.svg',
        name: 'Elnora',
        role: 'Lead Marketing Facilitator',
        // about: 'We need to generate the virtual CSS hard drive!',
        email: 'reid_oconnell4@yahoo.com',
        permissions:[]
        // contact: '506-654-1653',
        // location: 'Port Narcos',
        // groups: [
        //     {
        //         id: '#1Group_Kelli',
        //         avatar: 'friend-1.svg',
        //         name: 'Kelli'
        //     },
        //     {
        //         id: '#2Group_Laurence',
        //         avatar: 'friend-1.svg',
        //         name: 'Laurence'
        //     },
        //     {
        //         id: '#3Group_Melyssa',
        //         avatar: 'friend-1.svg',
        //         name: 'Melyssa'
        //     },
        //     {
        //         id: '#4Group_Montana',
        //         avatar: 'friend-1.svg',
        //         name: 'Montana'
        //     },
        //     {
        //         id: '#5Group_Johnathan',
        //         avatar: 'friend-1.svg',
        //         name: 'Johnathan'
        //     }
        // ],
        // Progress: {
        //     label: 'Progress',
        //     variant: 'primary',
        //     value: 60
        // }
    },
    
];

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/profile-list/list').reply(200, { users });
